<template>
  <v-dialog
    :value="reviewEditDialog"
    @input="$emit('update:reviewEditDialog', $event)"
    width="800"
    persistent
    @click:outside="$emit('cancel-review-edit')"
  >
    <v-card class="edit-review-dialog">
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="label-input primary--text" style="margin-bottom: 0">Edit Review</span>
        <v-btn icon @click="$emit('cancel-review-edit')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <div class="pa-6" v-if="editingReviewIndex !== null">
        <div class="wrap-review-form">
          <label class="label-input">Information Review</label>
          <v-row>
            <v-col cols="12" md="12">
              <v-text-field v-model="fields['body-reviews'][editingReviewIndex].fullName" label="Reviewer Full Name" />
            </v-col>
            <!-- Temporarily hide time, so hide date column -->
            <!-- <v-col cols="12" md="6">
              <ReviewDateTimeInput
                :value="fields['body-reviews'][editingReviewIndex]"
                @input="updateEditingReviewDateTime"
              />
            </v-col> -->
          </v-row>
          <v-text-field v-model="fields['body-reviews'][editingReviewIndex].title" label="Review Title" />
          <div class="mb-5">
            <label class="label-input">Rating</label>
            <v-rating
              color="warning"
              background-color="#c1c1c1"
              empty-icon="mdi-star-outline"
              full-icon="mdi-star"
              half-icon="mdi-star-half-full"
              hover
              length="5"
              size="35"
              v-model="fields['body-reviews'][editingReviewIndex].star"
            >
            </v-rating>
          </div>
          <div class="mb-5">
            <label class="label-input">Avatar Image</label>
            <UploadImage
              @callback="$emit('upload-avatar-from-dialog', $event)"
              :image="{ imageSrc: fields['body-reviews'][editingReviewIndex].avatar }"
              :height="`150`"
              :typeUpload="'image'"
              @callbackDelete="$emit('remove-avatar-from-dialog')"
            />
          </div>
          <div class="mb-5">
            <label class="label-input">Content</label>
            <ckeditor
              :editor="editor"
              v-model="fields['body-reviews'][editingReviewIndex]['content']"
              :config="editorConfig"
            />
          </div>
          <div>
            <div class="d-flex justify-space-between align-center mb-2">
              <label class="label-input">
                Review Images ({{ fields['body-reviews'][editingReviewIndex].images.length || 0 }})
              </label>
              <v-btn small text color="primary" @click="$emit('add-review-image', editingReviewIndex)">
                <v-icon size="16">mdi-plus</v-icon>
                <span>Add Image</span>
              </v-btn>
            </div>
            <div
              class="review-images-grid"
              v-if="
                fields['body-reviews'][editingReviewIndex].images &&
                  fields['body-reviews'][editingReviewIndex].images.length > 0
              "
            >
              <div
                v-for="(image, imageIndex) in fields['body-reviews'][editingReviewIndex].images"
                :key="imageIndex"
                class="review-image-item"
              >
                <div class="image-container">
                  <img :src="image.src" alt="" @click="$emit('preview-image', image.src)" />
                  <div class="image-overlay">
                    <v-btn
                      icon
                      small
                      @click="$emit('edit-review-image', editingReviewIndex, imageIndex)"
                      class="edit-btn"
                    >
                      <v-icon size="16" color="white">mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      small
                      @click="$emit('remove-review-image', editingReviewIndex, imageIndex)"
                      class="remove-btn"
                    >
                      <v-icon size="16" color="white">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="no-images-placeholder">
              <p>No images added yet. Click "Add Image" to upload review photos.</p>
            </div>
          </div>
        </div>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('cancel-review-edit')">Cancel</v-btn>
        <v-btn color="primary" @click="$emit('save-review-edit')">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
// import ReviewDateTimeInput from './review-date-time-input.vue'

export default {
  name: 'ReviewEditDialog',
  components: { UploadImage },
  props: {
    reviewEditDialog: { type: Boolean, required: true },
    fields: { type: Object, required: true },
    editingReviewIndex: { type: [Number, null], default: null },
    editor: { type: Function, required: true },
    editorConfig: { type: Object, required: true },
  },
  methods: {
    updateEditingReviewDateTime(nextReview) {
      if (this.editingReviewIndex === null) return;
      this.$set(this.fields['body-reviews'], this.editingReviewIndex, nextReview);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .ck-editor__editable_inline {
  min-height: 150px !important;
}
::v-deep .ck-editor__editable {
  min-height: 150px !important;
}
.label-input {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
  display: block;
}

.review-images-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
}

.review-image-item {
  position: relative;
}

.image-container {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  width: 90px;
  height: 90px;
}

.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.image-container:hover .image-overlay {
  opacity: 1;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-overlay .edit-btn,
.image-overlay .remove-btn {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

.no-images-placeholder {
  text-align: center;
  padding: 40px 20px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  color: #666;
  margin-top: 16px;
}

.no-images-placeholder p {
  margin: 0;
  font-style: italic;
}

.edit-review-dialog .v-card__title {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 10;
  border-bottom: 1px solid #e0e0e0;
  padding: 16px 24px;
}

.edit-review-dialog .v-card__actions {
  position: sticky;
  bottom: 0;
  background-color: #fff;
  z-index: 10;
  border-top: 1px solid #e0e0e0;
  padding: 16px 24px;
}

.edit-review-dialog .v-card__text {
  max-height: 70vh;
  overflow-y: auto;
  padding: 24px;
}
</style>
